import styled from 'styled-components';

export const ChatSection = styled.section`
  margin-top: 0;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
`;

export const ChatSectionHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
`;

export const ChatHeaderMain = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1;
`;

export const ChatBackButton = styled.button`
  flex-shrink: 0;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #e2e8f0;
  color: #334155;
  white-space: nowrap;

  &:hover {
    background: #cbd5e1;
  }
`;

export const ChatSectionTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
`;

export const ChatSectionSubtitle = styled.p`
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
`;

export const ChatActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ChatActionButton = styled.button`
  border: none;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: ${(p) => (p.$primary ? '#2563eb' : p.$danger ? '#dc2626' : '#e2e8f0')};
  color: ${(p) => (p.$primary || p.$danger ? '#fff' : '#334155')};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ChatMessagesViewport = styled.div`
  height: min(560px, calc(100vh - 280px));
  min-height: 360px;
  overflow-y: auto;
  padding: 20px;
  background: #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ChatBubbleRow = styled.div`
  display: flex;
  justify-content: ${(p) => (p.$side === 'right' ? 'flex-end' : 'flex-start')};
`;

export const ChatBubble = styled.div`
  max-width: 72%;
  padding: 10px 14px;
  border-radius: ${(p) => (p.$side === 'right' ? '16px 16px 4px 16px' : '16px 16px 16px 4px')};
  background: ${(p) => (p.$side === 'right' ? '#dcf8c6' : '#fff')};
  border: 1px solid ${(p) => (p.$side === 'right' ? '#b7e4a5' : '#e2e8f0')};
  box-shadow: 0 1px 1px rgba(15, 23, 42, 0.06);
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  color: #0f172a;
`;

export const ChatBubbleMeta = styled.div`
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
`;

export const ChatComposer = styled.form`
  display: flex;
  gap: 8px;
  padding: 14px 16px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
`;

export const ChatComposerInput = styled.textarea`
  flex: 1;
  min-height: 44px;
  max-height: 120px;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
`;

export const TakeoverBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${(p) => (p.$active ? '#fef3c7' : '#e0f2fe')};
  color: ${(p) => (p.$active ? '#92400e' : '#0369a1')};
`;

export const ConversationStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  background: ${(p) => {
    if (p.$status === 'suspenso') return '#ffedd5';
    if (p.$status === 'finalizado') return '#dcfce7';
    return '#e0f2fe';
  }};
  color: ${(p) => {
    if (p.$status === 'suspenso') return '#c2410c';
    if (p.$status === 'finalizado') return '#166534';
    return '#0369a1';
  }};
`;

export const PendingQuestionAlert = styled.div`
  margin: 0 16px 12px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #9a3412;
  font-size: 13px;
  line-height: 1.45;

  strong {
    display: block;
    margin-bottom: 4px;
    font-size: 13px;
  }
`;

export const AttentionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: #ffedd5;
  color: #c2410c;
`;

export const EmptyChatHint = styled.p`
  margin: auto;
  color: #64748b;
  font-size: 14px;
  text-align: center;
`;

export const ChatDaySeparator = styled.div`
  align-self: center;
  margin: 6px 0 4px;
  padding: 4px 12px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
`;

export const ChatMediaBlock = styled.div`
  margin-top: ${(p) => (p.$hasText ? '8px' : '0')};
`;

export const ChatMediaImageButton = styled.button`
  display: block;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  max-width: 100%;
`;

export const ChatMediaImage = styled.img`
  display: block;
  max-width: min(280px, 100%);
  max-height: 280px;
  border-radius: 8px;
  object-fit: cover;
`;

export const ChatMediaDocument = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: ${(p) => (p.$hasText ? '8px' : '0')};
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #0f172a;
  font-size: 13px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #eef2ff;
    border-color: #93c5fd;
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }
`;

export const ChatMediaDocumentIcon = styled.span`
  flex-shrink: 0;
  font-size: 22px;
  line-height: 1;
`;

export const ChatMediaDocumentLabel = styled.span`
  min-width: 0;
  word-break: break-word;
`;

export const ChatMediaAudio = styled.audio`
  display: block;
  width: min(280px, 100%);
  margin-top: ${(p) => (p.$hasText ? '8px' : '0')};
`;

export const ChatMediaHint = styled.span`
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
`;

export const ChatMediaViewerOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.78);
`;

export const ChatMediaViewerPanel = styled.div`
  display: flex;
  flex-direction: column;
  width: min(960px, 100%);
  max-height: calc(100vh - 48px);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.35);
`;

export const ChatMediaViewerToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
`;

export const ChatMediaViewerTitle = styled.div`
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChatMediaViewerToolbarButton = styled.button`
  margin-left: 8px;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #e2e8f0;
  color: #334155;

  &:hover {
    background: #cbd5e1;
  }
`;

export const ChatMediaViewerBody = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0f172a;
`;

export const ChatMediaViewerImage = styled.img`
  display: block;
  max-width: 100%;
  max-height: calc(100vh - 140px);
  object-fit: contain;
`;

export const ChatMediaViewerFrame = styled.iframe`
  display: block;
  width: 100%;
  height: min(80vh, 720px);
  border: none;
  background: #fff;
`;
